export function DtoReqUpdateInfo() {
    return {
        idUsuario: "",
        dicTipoDocumento: "",
        identificacion: "",
        nombres: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        correoElectronico: "",
        numeroCelular: "",
        validacionData: "",
        fechaCreacion: "",
        fechaActualizacion: "",
        fechaCambioClave: "",
        estadoUsuario: "1",
        tipoEstado: "1",
        fechaUltimoLogin: "",
        cantidadIntentos: "",
        ultimaFechaCambioClave: "",
        diasRestantesCambioClave: "",
        vigente: "",
        instafitUrl: "",
        Codigo: "",
        FechaExpiracionCodigo: "",
        cantidadIntentosRecClave: ""
    }
}